import { branch, withProps } from 'recompose'
import Container from './Container'

export default branch(({ fluid }) => !!fluid, withProps({ maxWidth: '100%' }), withProps({ maxWidth: 8 }))(Container)
